'use strict';

ebReadOnlyField.$inject = [];

function ebReadOnlyField() {
    return {
        restrict: 'E',
        templateUrl: require('./ebReadOnlyField.html'),
        scope: {
            for: '@',
            label: '@',
            placeholder: '@',
            model: '='
        }
    };
}

module.exports = ebReadOnlyField;



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/directives/ebReadOnlyFieldDirective.js
// module id = 46
// module chunks = 0